import React from "react";
import { Card, CardHeader } from "../../UI/DesignStandards";
import BowlerSidepotSelection from "../SidepotSelection/BowlerSidepotSelection";
import { formatCurrency } from "../../UI/DesignStandards";

const EntrySidepotsCard = ({
  sidepotEvents,
  slots,
  selectedSidepots,
  onSidepotToggle,
}) => {
  if (!sidepotEvents?.length) return null;
  const named = slots.filter((slot) => String(slot.name || "").trim());
  if (!named.length) return null;

  const getBowlerSidepotCount = (name) =>
    Object.values(selectedSidepots[name] || {}).filter(Boolean).length;

  return (
    <Card className="mb-8">
      <CardHeader
        title="Sidepots"
        subtitle="Optional. Does not change which event or squad you can pick."
      />
      <div className="p-6 space-y-4">
        {named.map((bowler, index) => (
          <BowlerSidepotSelection
            key={`${bowler.name}-${index}`}
            bowler={bowler}
            index={index}
            sidepotEvents={sidepotEvents}
            selectedSidepots={selectedSidepots}
            onSidepotToggle={onSidepotToggle}
            getBowlerSidepotCount={getBowlerSidepotCount}
            formatCurrency={formatCurrency}
          />
        ))}
      </div>
    </Card>
  );
};

export default EntrySidepotsCard;
